import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-verify-checkmark',
  templateUrl: './verify-checkmark.component.html',
  styleUrls: ['./verify-checkmark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyCheckmarkComponent {}
